export enum ModalType {
  DEFAULT,
  IMAGE,
  VIDEO,
}
